import { HttpEndpoint } from '../httpEndpoints';
import { delay } from '@shared/utils/async';
import { getFakeSembonus } from './sembonus.fake';
import { Cart } from '@/api/Cart/cart.interfaces';

export class SembonusEndpoint extends HttpEndpoint {
    constructor(applicationUrl: string) {
        super(applicationUrl);
    }

    public async UpdateAppliedBonus(bonus: number[], cart: Cart): Promise<Cart> {
        return await this.post('mvc/Sembonus/UpdateAppliedBonusNights', {
            appliedBonusNightsValues: bonus,
            serialisedCartAndOptionsForBooking: JSON.stringify(cart),
        });
    }
}
export class FakeSembonusEndpoint {
    public async UpdateAppliedBonus(bonus: number[], cart: Cart): Promise<Cart> {
        const response = getFakeSembonus(bonus, cart);
        await delay(500);
        return response;
    }
}
